import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GoPage = lazy(() => import('../pages/go/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  // 原版 LP 備份路徑（測試期間原版仍可訪問驗證）
  {
    path: '/lp',
    element: <HomePage />,
  },
  {
    path: '/go',
    element: <GoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
